import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

type UrlFeatureFlag = {
  // define something here, when you have a feature flag
};

type UrlFeatureFlagState = UrlFeatureFlag & {
  // enables the preview mode for the customer menu
  previewMode: boolean;
};

const DefaultUrlFeatureFlag: UrlFeatureFlagState = {
  previewMode: false,
};

type UrlFeatureFlagProviderProps = React.PropsWithChildren & {
  previewMode?: boolean;
};

const UrlFeatureFlagContext = createContext<UrlFeatureFlagState>(
  DefaultUrlFeatureFlag
);

/**
 * A feature flag provider that sources the feature flags from the URL query params.
 *
 * The feature flag is persisted even when the user navigates away from the page, or to a url without the feature flag.
 * The feature flag is updated by changing the URL query params.
 */
export const UrlFeatureFlagProvider = ({
  children,
  previewMode = false,
}: UrlFeatureFlagProviderProps) => {
  const [urlFeatureFlag, setUrlFeatureFlag] = useState<UrlFeatureFlag>(
    DefaultUrlFeatureFlag
  );

  // Set the feature flag here based on the url.
  // useEffect(() => {
  //   const urlSearchParams = new URLSearchParams(window.location.search);
  //   const newJourney = urlSearchParams.get("new_journey");
  //   if (newJourney !== null) {
  //     setUrlFeatureFlag({ new_journey: newJourney.toLowerCase() !== "false" });
  //   }
  // }, [window.location.search]);

  const values = useMemo(() => {
    return { ...urlFeatureFlag, previewMode };
  }, [urlFeatureFlag, previewMode]);

  return (
    <UrlFeatureFlagContext.Provider value={values}>
      {children}
    </UrlFeatureFlagContext.Provider>
  );
};

export const useUrlFeatureFlag = () => useContext(UrlFeatureFlagContext);
